module.exports = __webpack_public_path__ + "img/media-21.7a575e3f.png";